var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 1.5C9.75 1.875 9.75 1.836 9.75 2.25V8.25C9.75 8.664 9.75 8.25 9.75 9H21C21 8.625 21 8.664 21 8.25V2.25C21 1.836 21 2.25 21 1.5H9.75ZM14.25 10.125V14.625H16.5V10.125H14.25ZM12.375 12C10.9567 12 9.28125 13.863 9 15H7.5V21H9C10.0005 21.75 10.5 22.5 12 22.5H16.415C16.9025 22.5 17.3251 22.1603 17.4316 21.6841L18.4688 17.0156C18.6128 16.3661 18.1181 15.75 17.4521 15.75H13.125C13.125 15.375 13.125 15.414 13.125 15V12H12.375ZM3.00001 14.25C3 14.625 3 14.418 3 14.625V21.375C3 21.582 3 21.375 3.00001 21.75H6.375C6.375 21.375 6.375 21.582 6.375 21.375V14.625C6.375 14.418 6.375 14.625 6.375 14.25H3.00001Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBid);
export default __webpack_public_path__ + "static/media/icon-bid.820cbc2720f958ad9ad5de9d7978c9a8.svg";
export { ForwardRef as ReactComponent };